import React from 'react';
import { NO_ERP_INTEGRATION_MESSAGE } from '@/services/postingLogApi';
import { AlertCircle } from 'lucide-react';

export const IntegrationBanner: React.FC = () => (
  <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-300 mb-4">
    <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
    <span>{NO_ERP_INTEGRATION_MESSAGE}. Failed lines can't be retried until an ERP integration is set up.</span>
  </div>
);
